export interface EditorState {
  value: boolean
}

export const editorInitialState: EditorState = {
  value: false
}
